import Loading from 'component/Loading';
import Modal from 'component/Modal';
import MicroModal from 'micromodal';
import {Suspense, useEffect, useState} from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { api_commonFetch } from 'util';

export default function Home(){
    return (
        <Suspense fallback={<Loading/>}>
            <App/>
        </Suspense>
    );
}

export function App(){

    const navigate = useNavigate();
    const date = new Date();
    const nextDate = new Date(date.getFullYear(), date.getMonth()+1, 0);
    const [params, setParams] = useSearchParams();
    const [vo, setVO] = useState({
        searchStartDate : params.get('searchStartDate') || new Date(date.getTime() + (9 * 60 * 60 * 1000)).toISOString().split("T")[0]
        , searchEndDate : params.get('searchEndDate') || new Date(nextDate.getTime() + (9 * 60 * 60 * 1000)).toISOString().split("T")[0]
    });
    const [loading, setLoading] = useState(true);

    const [scsFoodMenuList, setScsFoodMenuList] = useState([]);

    const fn_getScsFoodMenuList = async()=>{
        setLoading(true);
        const url = process.env.REACT_APP_API_URL + '/food?' + new URLSearchParams(vo);
        const config = {method : 'get'}
        const data = await api_commonFetch(url, config);

        setScsFoodMenuList(data.foodList);
        setLoading(false);
    }

    const fn_search = ()=>{
        const form = document.searchForm;
        const tmp = {
            ...vo
            , searchStartDate : form.searchStartDate.value
            , searchEndDate : form.searchEndDate.value
        }
        setVO(tmp);
        navigate('/food?' + new URLSearchParams(tmp));
    }

    const fn_update = (ob)=>{        
        const form = document.postForm;
        form.menuNo.value = ob.menuNo;
        form.menuDate.value = ob.menuDate;
        form.menuItem.value = ob.menuItem;
        MicroModal.show("modal");        
    }

    const fn_postForm = async()=>{

        const url = process.env.REACT_APP_API_URL + '/foodInsertAction'
        const form = document.postForm;
        const formData = new FormData(form);
        const config = {method : 'post', body : formData}
        const msg = "수정하시겠습니까?"

        await Swal.fire({
            title: msg
            , showCancelButton: true
            , confirmButtonText: "확인"
            , cancelButtonText: `취소`
        }).then(async (result) => {
            if (result.isConfirmed) {
                Swal.fire({
                    title: "처리중입니다.",
                    html: "잠시만 기다려주시기 바랍니다.",
                    allowOutsideClick: false,
                    didOpen: () => {
                        Swal.showLoading();
                    },
                });
                
                const data = await api_commonFetch(url, config);
                
                if(data>0){
                    await Swal.fire("정상적으로 처리되었습니다.");
                    fn_getScsFoodMenuList();
                    MicroModal.close('modal');
                }else{
                    await Swal.fire("처리중 오류가 발생하였습니다.");
                }
            }
        });
    }

    useEffect(()=>{
        fn_getScsFoodMenuList();
    }, [vo]);

    return (
        <>
            <form name='searchForm' onSubmit={(e)=>{fn_search();}} className="search-form">
                <div className="col-6">
                    <input type='date' name="searchStartDate" defaultValue={vo.searchStartDate} onChange={(e)=>{fn_search();}}/>
                </div>
                <div className="col-6">
                    <input type='date' name="searchEndDate" defaultValue={vo.searchEndDate} onChange={(e)=>{fn_search();}}/>
                </div>
            </form>

            <table className="table list">
                <thead>
                    <tr>
                        <th>날짜</th>
                        <th>메뉴</th>
                        <th>이미지</th>
                    </tr>
                </thead>
                <tbody>
                {
                    loading == true ? (
                        <>
                            <tr>
                                <td colSpan={99}>
                                    로딩중...
                                </td>
                            </tr>
                        </>
                    ) : (
                        scsFoodMenuList!=null && scsFoodMenuList.length>0 ? (
                            scsFoodMenuList.map((ob, i)=>{
                                return (
                                    <tr key={i}>
                                        <td>
                                            {ob.menuDate}
                                        </td>
                                        <td className="text-left">
                                            <span dangerouslySetInnerHTML={{__html : ob.menuItem.split(" ").join("<br/>")}}></span>
                                        </td>
                                        <td>
                                            {
                                                ob.img != null && ob.img != '' ? (
                                                    <a href={"https://crizel.duckdns.org/crizel/upload/scsFoodMenu/" + ob.img} target="_blank">
                                                        <img src={"https://crizel.duckdns.org/crizel/upload/scsFoodMenu/" + ob.img}/>
                                                    </a>
                                                ) : (
                                                    <>
                                                        <button className="btn btn-success" onClick={(e)=>{
                                                            e.preventDefault();
                                                            fn_update(ob);
                                                        }}>
                                                        수정
                                                        </button>
                                                    </>
                                                )
                                            }
                                        </td>
                                    </tr>
                                );
                            })
                        ) : ''
                    )
                    
                }
                </tbody>
            </table>

            <Modal id="modal">
                <form name="postForm" onSubmit={(e)=>{fn_postForm(); e.preventDefault();}}>
                    <input type="hidden" name='menuNo'/>
                    <table className="table">
                        <colgroup>
                            <col style={{width:'25%'}}/>
                            <col style={{width:'75%'}}/>
                        </colgroup>
                        <tbody>
                            <tr>
                                <th>날짜</th>
                                <td className="text-left">
                                    <input type="date" name="menuDate" readOnly/>
                                </td>
                            </tr>
                            <tr>
                                <th>메뉴</th>
                                <td className="text-left">
                                    <input type="text" name="menuItem" className="col-12"/>
                                </td>
                            </tr>
                            <tr>
                                <th>이미지</th>
                                <td className="text-left">
                                    <input type="file" name="upload"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div className="text-center">
                        <button className="btn btn-primary" onClick={(e)=>{
                            fn_postForm();
                        }}>등록</button>
                        <button className="btn btn-list" onClick={(e)=>{
                            e.preventDefault();
                            MicroModal.close("modal");
                        }}>닫기</button>
                    </div>
                </form>
            </Modal>
        </>
    );
}